import React from "react";
import { useSelector } from "react-redux";
import EmptyListTemplate from "../../common/components/emptyListTemplate/emptyListTemplate";
import PromotionOnePlusN from "./components/promotion(1+n)/promotion(1+n)";
import PromotionOneplusNplusN from "./components/promotion(1+n+n)/promotion(1+n+n)";
import PromotionAPlusB from "./components/promotion(a+b)/promotion(a+b)";
import PromotionNplusNplusN from "./components/promotion(n+n+n)/promotion(n+n+n)";
import PromotionBasic from "./components/promotionBasic/promotionBasic";
import styles from "./promotion.scss";

function PlpPromotion(props) {
  const { Link, NextHead } = props;

  const template = useSelector(
    (state) => state.plpState && state.plpState.template
  );

  const promotionProducts = useSelector(
    (state) => state.plpState && state.plpState.promotionProducts
  );

  const emptyListTemplate = (
    <div className={styles["empty-list"]}>
      <EmptyListTemplate message="沒有促銷商品" />
    </div>
  );

  const renderTemplate = () => {
    switch (template) {
      case "Basic":
        return <PromotionBasic Link={Link} NextHead={NextHead} template={template} />;
      case "1+N":
        return <PromotionOnePlusN Link={Link} NextHead={NextHead} template={template} />;
      case "1+N+N":
        return <PromotionOneplusNplusN Link={Link} NextHead={NextHead} template={template} />;
      case "A+B":
        return <PromotionAPlusB Link={Link} NextHead={NextHead} template={template} />;
      case "N+N+N":
        return <PromotionNplusNplusN Link={Link} NextHead={NextHead} template={template} />;
      default:
        return emptyListTemplate;
    }
  };

  if (!promotionProducts) return emptyListTemplate;

  return <div>{renderTemplate()}</div>;
}

export default PlpPromotion;
